import { useTheme } from "../../context/useThemeContext";
import useMainStore from "../../stores/mainStore";
import TabsContainer from "./tabs/tabsContainer";
import useIsLeftSidebarOverlay from "../../hooks/useIsLeftSidebarOverlay";
import { ProfileIcon } from "./ProfileIcon";
import { SyncButton } from "./syncButton/syncButton";

function RightHeader() {
    // Context
    const { theme } = useTheme();

    // Store
    const leftSidebarCollapsed = useMainStore(
        (state) => state.data.leftSidebarCollapsed
    );

    const leftSidebarIsOverlay = useIsLeftSidebarOverlay();

    
    return (
        <div
            className="w-full h-[42px] bg-red-500 flex items-center relative shrink-0"
            style={{
                backgroundColor: theme.headerColor,
            }}
        >
            <div
                className="collapsedSpacer "
                style={{
                    width: !leftSidebarCollapsed
                        ? !leftSidebarIsOverlay // If left sidebar is overlay, keep the padding for tabs
                            ? "0px"
                            : "48px"
                        : "48px",
                    transition: "width 0.1s ease-in-out",
                    transitionDelay: !leftSidebarCollapsed ? "0s" : "0.05s",
                }}
            />

            <TabsContainer />

            <div className="gap-[1px] flex items-center">
                <SyncButton />
                <ProfileIcon />
            </div>
        </div>
    );
}

export default RightHeader;
